export enum PaymentMethod {
    ideal = 'ideal',
    invoice = 'invoice',
}
